import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-types-papi';
import ConfirmationPopup from '@wix/da-shared-react/pkg/Popup/ConfirmationPopup';
import BiLink from '@wix/da-shared-react/pkg/biLogger/Components/BiLink';
import { useWatchButton } from '@wix/da-shared-react/pkg/WatchButton/useWatchButton';

export interface Props {
  group: PapiUser;
  popModal: () => void;
}

const GroupClosedWatchModal: React.FC<Props> = ({ group, popModal }) => {
  const { t } = useTranslation();
  const { biData, onClick } = useWatchButton(group);

  const onWatch = useCallback(() => {
    onClick();
    popModal();
  }, [popModal, onClick]);

  return (
    <ConfirmationPopup
      onCancel={popModal}
      onConfirm={onWatch}
      title={t('group.join.closed.popup.title')}
      text={
        <div>
          <div>
            {t('group.join.closed.popup.body', { groupname: group.username })}
          </div>
          <div>
            {/* TODO actual url */}
            <BiLink href="/">
              {t('group.join.closed.popup.link.whatIsWatch')}
            </BiLink>
          </div>
        </div>
      }
      cancelBtnLabel={t('group.join.closed.popup.button.cancel')}
      confirmBtnLabel={t('group.join.closed.popup.button.watch')}
      confirmBtnBiData={biData}
      isOpen
    />
  );
};
GroupClosedWatchModal.displayName = 'GroupClosedWatchModal';

export default GroupClosedWatchModal;
